import { createFileRoute, redirect } from '@tanstack/react-router';
import { sessionQueryOptions } from '@entities/session';
import { useFirstLoginStore } from '@features/first-login-otp';
import { FirstTimeLoginOtpPage } from '@pages/first-time-login-otp-verification';
import { PageTransition } from '@ui';

export const Route = createFileRoute('/first-time-login-otp-verification')({
  beforeLoad: async ({ context }) => {
    const user = await context.queryClient.ensureQueryData(sessionQueryOptions).catch(() => null);
    if (user) throw redirect({ to: '/' });

    const userId = useFirstLoginStore.getState().userId;
    if (!userId) throw redirect({ to: '/login' });
  },
  component: FirstTimeLoginOtpRoute,
});

function FirstTimeLoginOtpRoute() {
  return (
    <PageTransition>
      <FirstTimeLoginOtpPage />
    </PageTransition>
  );
}
